import { broadcastCurrentSlideState } from './currentSlideBroadcast';

/**
 * When auto-advance is on and the user is on the last slide of a deck, advance the
 * playlist to the next deck via localStorage (presenter / audience windows mirror the console).
 *
 * @returns {object|null} Next deck `{ id, playlistPositionId, name }` if advanced, else null.
 */
export function advancePlaylistToNextDeckIfAtLastSlide({
  currentPresentationId,
  currentSlideIndex,
  deckSlideCount,
  autoAdvance,
}) {
  if (!autoAdvance || !currentPresentationId || deckSlideCount <= 0) return null;
  if (currentSlideIndex < deckSlideCount - 1) return null;

  let playlist = null;
  try {
    const raw = localStorage.getItem('deckpack-playlist-context');
    if (raw) playlist = JSON.parse(raw);
  } catch {
    return null;
  }
  const decks = playlist?.slides;
  if (!Array.isArray(decks) || decks.length < 2) return null;

  const idx = decks.findIndex((d) => String(d.id) === String(currentPresentationId));
  if (idx < 0 || idx >= decks.length - 1) return null;

  const next = decks[idx + 1];
  if (!next?.id) return null;

  const ts = Date.now();
  const slidePayload = {
    presentationId: next.id,
    index: 0,
    slideCount: 0,
    timestamp: ts,
  };
  try {
    localStorage.setItem('current-slide-state', JSON.stringify(slidePayload));
    broadcastCurrentSlideState(slidePayload);
    localStorage.setItem(
      'active-presentation',
      JSON.stringify({
        presentationId: next.id,
        playlistPositionId: next.playlistPositionId,
        name: next.name,
        timestamp: ts,
      })
    );
  } catch {
    return null;
  }

  return {
    id: String(next.id),
    playlistPositionId: next.playlistPositionId,
    name: typeof next.name === 'string' ? next.name : '',
  };
}
